import Axios from "@/plugins/axios.ts";
import type {Source} from "@/domain/type/source.type.ts";
import type {AxiosResponse} from "axios";
import type {Company, CompanyEmployeeCandidate, CompanyEmployeeAddResponse, CompanyEmployeesResponse, CompanyEmployeesMatchResponse, CompanyExistsResponse} from "@/domain/type/company.api.type.ts";

class CompanyApi {
  createCompany(siret: string, companyName: string, source: Source): Promise<AxiosResponse<void>> {
    return Axios.post(`/company`, {siret: siret, companyName: companyName, source: source});
  }

  async getCompany(siret: string, source: Source): Promise<null | Company> {
    const response: AxiosResponse<Company> = await Axios.get(`/company?siret=${siret}&source=${source}`)
    if (response.data.siret) {
      return response.data;
    }
    return null;
  }

  exists(siret: string, source: Source): Promise<AxiosResponse<CompanyExistsResponse>> {
    return Axios.get(`/company/exists?siret=${siret}&source=${source}`);
  }

  getEmployees(siret: string, source: Source): Promise<AxiosResponse<CompanyEmployeesResponse>> {
    return Axios.get(`/company/employees?siret=${encodeURIComponent(siret)}&source=${source}`);
  }

  matchEmployees(siret: string, employees: CompanyEmployeeCandidate[], source: Source): Promise<AxiosResponse<CompanyEmployeesMatchResponse>> {
    return Axios.post(`/company/employees/matches?source=${source}`, {siret, employees});
  }

  addEmployee(siret: string, employeeId: number, source: Source, target: Source): Promise<AxiosResponse<CompanyEmployeeAddResponse>> {
    return Axios.post(`/company/employees`, {siret, employeeId, source, target});
  }
}

export default new CompanyApi();
